import styles from 'components/UI/V3/Timeline/Item/Divider/TimelineItemDivider.module.scss';
import React from 'react';

export const TimelineItemDivider: React.FC = () => {
    return <div className={styles.root} />;
};
